"use client";

import * as React from "react";
import Link from "next/link";

import { Info, Video, CloudDownload } from "lucide-react";
import { cn } from "@/lib/helpers/utils";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";

import QuranDrawer from "@/components/ui/drawer/quran-drawer";

import { Button, buttonVariants } from "@/components/ui/button";
import { Settings as GearIcon } from "lucide-react";
import { LogoMain2 } from "@/app/icons/logo-main2";
import IconPdf from "@/app/icons/icon-pdf";
import IconXls from "@/app/icons/icon-xls";
import { videoCategories } from "@/lib/data/videos-categories";

export function HomeNavbar({ children }: { children: React.ReactNode }) {
  const [isOpen, onToggle] = React.useState<boolean>(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b-2 border-border/40 backdrop-blur-sm supports-backdrop-filter:bg-transparent">
      <div className="pr-6 pl-6 flex flex-col md:flex-row md:h-14 w-full items-center">
        <div className="pt-3 pb-3 w-full md:w-auto">
          <div className="flex flex-row ">
            <div className="font-extrabold text-foreground flex flex-row justify-between items-center w-full md:w-auto">
              <Link href="/" className="flex justify-center items-center">
                <div className="text-primary mr-1">
                  <LogoMain2 className="w-10 h-10 bg-primary/80 p-1 rounded-md text-white" />

                  {/* <LogoMain4 className="w-8 h-8" /> */}
                </div>
                <div>QuranExcel</div>
              </Link>

              <Button
                onClick={() => onToggle((s) => !s)}
                className={`${buttonVariants({ variant: "bgGhost" })} p-2.5 block md:hidden`}
              >
                <GearIcon className="h-5 w-5 " />
              </Button>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-center w-full align-middle">
          <NavigationMenu className="">
            <NavigationMenuList className="">
              <NavigationMenuItem className="focus:bg-primary/20">
                <NavigationMenuTrigger className="">
                  <div className="flex flex-row items-center">
                    <CloudDownload className="h-4 w-4 mr-1 text-primary" />
                    <div>Downloads</div>
                  </div>
                </NavigationMenuTrigger>
                <NavigationMenuContent>
                  <ul className="grid gap-3  p-4 md:w-[400px] lg:w-[500px] lg:grid-cols-[1fr_1fr]">
                    <li className="row-span-3">
                      <NavigationMenuLink
                          className="flex h-full w-full select-none flex-col justify-start rounded-md bg-primary/10 p-6 no-underline outline-hidden focus:shadow-md"
                          href="/files/excel"
                        >
                          <div className="mb-2 mt-4 text-lg font-medium">
                            <div className="flex flex-row items-center">
                              <IconXls className="h-12 w-12 mr-1" />
                              {/* <FaFileExcel className="h-7 w-7 mr-1 text-primary" /> */}
                              <div>Excel Files</div>
                            </div>
                          </div>
                          <p className="text-sm leading-tight text-muted-foreground">
                            Explore xls section to download Quran files in Excel
                            file format, making your study and reference more
                            convinent than ever.
                          </p>
                      </NavigationMenuLink>
                    </li>

                    <li className="row-span-3">
                      <NavigationMenuLink
                          className="flex h-full w-full select-none flex-col justify-start rounded-md bg-primary/10 p-6 no-underline outline-hidden focus:shadow-md"
                          href="/files/pdf"
                        >
                          {/* <Icons.logo className="h-6 w-6" /> */}
                          <div className="mb-2 mt-4 text-lg font-medium">
                            <div className="flex flex-row items-center">
                              <IconPdf className="h-12 w-12 mr-1" />
                              {/* <FaFilePdf className="h-7 w-7 mr-1 text-primary" /> */}
                              <div>Pdf files</div>
                            </div>
                          </div>
                          <p className="text-sm leading-tight text-muted-foreground">
                            Visit PDF section to download the Quran in a
                            portable format with larger fonts for convenient
                            read and study.
                          </p>
                      </NavigationMenuLink>
                    </li>
                  </ul>
                </NavigationMenuContent>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuTrigger className="bg-transparent">
                  <div className="flex flex-row items-center">
                    <Video className="h-4 w-4 mr-1 text-primary" />
                    <div>Videos</div>
                  </div>
                </NavigationMenuTrigger>
                {/*TODO: Must enable Videos */}
                {/* <NavigationMenuContent> */}
                {/*   <ul className="grid w-full gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px] "> */}
                {/*     {videoCategories.map((video) => ( */}
                {/*       <ListItem */}
                {/*         key={video.title} */}
                {/*         title={video.title} */}
                {/*         href={video.href} */}
                {/*         className="p-3" */}
                {/*       > */}
                {/*         {video.description} */}
                {/*       </ListItem> */}
                {/*     ))} */}
                {/*   </ul> */}
                {/* </NavigationMenuContent> */}
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink
                  href="/about-us"
                  className={navigationMenuTriggerStyle() + " bg-transparent"}
                >
                  <div className="flex flex-row items-center">
                    <Info className="h-4 w-4 mr-1 text-primary" />
                    <div>About</div>
                  </div>
                </NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        <Button
          onClick={() => onToggle((s) => !s)}
          className={`${buttonVariants({ variant: "bgGhost" })} p-2.5 hidden md:block`}
        >
          <GearIcon className="h-5 w-5 " />
        </Button>
      </div>
      <QuranDrawer drawerOpen={isOpen} closeDrawer={onToggle}>
        {children}

        {/* <Accordion */}
        {/*   defaultValue="color-schemes" */}
        {/*   type="single" */}
        {/*   collapsible */}
        {/*   className="AccordionDiv" */}
        {/* > */}
        {/*   <AccordionItem value="color-schemes"> */}
        {/*     <AccordionTrigger className="hover:bg-secondary pl-3 pr-3 rounded-md"> */}
        {/*       <div className="flex flex-row p "> */}
        {/*         <ColorPaletteIcon */}
        {/*           className="w-5 h-5" */}
        {/*           style={{ */}
        {/*             fill: "hsl(var(--primary))", */}
        {/*             color: "hsl(var(--primary))", */}
        {/*           }} */}
        {/*         /> */}
        {/*         <div className="ml-3">Color Schemes</div> */}
        {/*       </div> */}
        {/*     </AccordionTrigger> */}
        {/*     <AccordionContent> */}
        {/*       <ColorSchemesSelector /> */}
        {/*     </AccordionContent> */}
        {/*   </AccordionItem> */}
        {/* </Accordion> */}
      </QuranDrawer>
    </header>
  );
}

const ListItem = React.forwardRef<
  React.ElementRef<"a">,
  React.ComponentPropsWithoutRef<"a">
>(({ className, title, children, ...props }, ref) => {
  return (
    <li>
      <NavigationMenuLink asChild>
        <a
          ref={ref}
          className={cn(
            "block select-none space-y-1 rounded-md leading-none no-underline outline-hidden transition-colors hover:bg-primary/15 hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
            className,
          )}
          {...props}
        >
          <div className="text-sm font-medium leading-none">{title}</div>
          <p className="line-clamp-2 text-sm leading-snug text-muted-foreground">
            {children}
          </p>
        </a>
      </NavigationMenuLink>
    </li>
  );
});
ListItem.displayName = "ListItem";
